export interface DocumentMetadata {
  fileUrl: string;
  fileType: "image" | "pdf" | "text" | "code-derived" | "git-diff";
  fileName: string;
  mimetype: string;
  tags: string[];
  git_url?: string;
  htmlContent?: HTMLDocumentMetadata[]

}

export interface HTMLDocumentMetadata {
  fileUrl: string;
  html: string;
  fileName: string;
}

export interface Document {
  _id: number;
  createdAt: string;
  updatedAt: string;
  status: "active" | "processing" | "inactive" | "error";
  uuid: string;
  content: string;
  agent?: string;
  fileIndexedStatus: StatusEnum;
  // Generation status per ontology, computed by the documents API from the run
  // tables; null = never generated.
  ontologyStatus?: OntologyStatus;
  executionId?: string;
  metadata: DocumentMetadata;
  type: "artifact" | "document" | "code";
  /** Code diff documents only (type "code"): the repository and commit range. */
  codeOntologyId?: number | null;
  baseCommitId?: string | null;
  headCommitId?: string | null;
}

// A document's newest generation job for one ontology (breezeai-backend
// DocumentOntologyStatusService).
export interface OntologyStatusEntry {
  // the job's own state
  status: "pending" | "running" | "done" | "error" | "cancelled";
  // the run's state: running | review | applying | applied | rejected | error | cancelled | ...
  runStatus: string | null;
  runId: string | null;
  jobId: string;
  agent: string | null;
  errorMessage: string | null;
  failedStep: string | null;
  erroredAt: string | null;
  updatedAt: string;
  // Problems that did not stop the run (ontology_failed, revision_failed, left_out, uncited). Absent from a backend
  // that predates it.
  warnings?: { kind: string; message: string; ontology?: string; failedStep?: string | null; items?: string[] }[];
}

export interface OntologyStatus {
  functional: OntologyStatusEntry | null;
  architecture: OntologyStatusEntry | null;
  design: OntologyStatusEntry | null;
  code: OntologyStatusEntry | null;
}

export enum StatusEnum {
  none = "none",
  inprogress = "inprogress",
  done = "done",
  error = "error",
}
